import React from 'react'

import * as Styled from './FinanceExampleTextBox.styles'

const FinanceExampleTextBox = () => {
  return (
    <Styled.FinanceExampleContainer>
      <Styled.FinanceExampleTitle>Representative example</Styled.FinanceExampleTitle>
      <p>
        Provided by PayPal Credit: assumed credit limit £1,200, representative 23.9% APR (variable), purchase rate 23.9%
        p.a. (variable).
      </p>
    </Styled.FinanceExampleContainer>
  )
}

export default FinanceExampleTextBox
